import * as React from "react";
import { EventRow } from "./EventRow";
import { OVERLAY_LIMIT, type UnifiedItem } from "./types";
import { DateTimeField } from "@/components/ui/datetime-field";

interface HistoryOverlayProps {
  items: UnifiedItem[];
  onClose: () => void;
}

export function HistoryOverlay({ items, onClose }: HistoryOverlayProps) {
  const [from, setFrom] = React.useState<string | null>(null);
  const [to, setTo] = React.useState<string | null>(null);

  // Filtro por período (inclusivo) sobre os itens carregados.
  const filtered = React.useMemo(() => {
    const fromT = from ? new Date(from).getTime() : null;
    const toT = to ? new Date(to).getTime() : null;
    return items.filter((it) => {
      const t = new Date(it._at).getTime();
      return (fromT === null || t >= fromT) && (toT === null || t <= toT);
    });
  }, [items, from, to]);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions -- backdrop click fecha; botao Fechar tem mesma acao
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-[oklch(20%_0.01_80_/_0.4)] p-4 motion-safe:animate-fade-in"
      role="dialog"
      aria-modal="true"
      aria-label="Histórico completo de eventos"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="max-h-[80vh] w-[min(720px,calc(100vw-32px))] overflow-y-auto rounded-[10px] border border-border-subtle bg-bg-surface p-5 shadow-rd-xl motion-safe:animate-scale-in">
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-[18px] font-semibold tracking-tight text-text-primary">
            Histórico completo
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="h-8 rounded-md px-3 text-[13px] font-medium text-text-secondary hover:bg-bg-muted-rd focus-visible:outline-none focus-visible:[box-shadow:var(--rd-shadow-focus)]"
          >
            Fechar
          </button>
        </div>

        <div className="mb-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
          <DateTimeField id="hist-from" label="De" value={from} onChange={setFrom} />
          <DateTimeField id="hist-to" label="Até" value={to} onChange={setTo} />
        </div>

        <ol className="divide-y divide-border-subtle">
          {filtered.slice(0, OVERLAY_LIMIT).map((it) => (
            <EventRow key={it.id} item={it} />
          ))}
        </ol>
        {filtered.length === 0 ? (
          <p className="mt-2 text-[11px] text-text-tertiary">Nenhum item no período selecionado.</p>
        ) : filtered.length > OVERLAY_LIMIT ? (
          <p className="mt-2 text-[11px] text-text-tertiary">
            Mostrando {OVERLAY_LIMIT} de {filtered.length} itens mais recentes.
          </p>
        ) : null}
      </div>
    </div>
  );
}
